export const authMethod = {
    oidc: 'Azure AD', 
    local:'Local'
  }